<template>
  <time
    v-if="value"
    :datetime="value"
    :auto-update="updateInterval"
    class="app-time-ago"
    :class="{ small }"
  />
</template>

<script>
import ptBR from 'timeago.js/esm/lang/pt_BR'
import { render, register } from 'timeago.js'

register('pt_BR', ptBR)

export default {
  name: 'AppTimeAgo',
  inheritAttrs: false,

  props: {
    value: {
      type: String | Object,
      required: true,
    },

    updateInterval: {
      type: Number,
      default: 60,
    },

    small: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    render(this.$el, 'pt_BR', {
      minInterval: this.updateInterval / 60,
    })
  },
}
</script>

<style lang="scss" scoped>
.app-time-ago {
  &.small {
    font-size: smaller;
  }
}
</style>
